// --- BUNDLE LOGIC JS ---

function updateTotal() {
  let total = 0;
  document.querySelectorAll(".product-list__item").forEach(function (item) {
    const qtyInput = item.querySelector("input[type='number']");
    const priceText = item.querySelector(".product-list__price");
    const unitPrice = parseFloat(priceText.dataset.price) / 100 || 0;
    const qty = parseInt(qtyInput.value, 10) || 0;
    total += qty * unitPrice;

    // Update individual line total
    priceText.textContent = "$" + (unitPrice * qty).toFixed(2);
  });

  const totalEl = document.getElementById("bundle-total");
  if (totalEl) {
    totalEl.textContent = "Total: $" + total.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".system-size-btn");
  const sizeOptions = JSON.parse(document.getElementById("size-options-data").textContent);

  const inputs = document.querySelectorAll("input[type='number']");
  const skus = Array.from(inputs).map(input => {
    const item = input.closest(".product-list__item");
    const sku = item?.getAttribute("data-sku");
    return { input, sku };
  });

  function updateItemVisibility() {
    const selectedBtn = document.querySelector(".system-size-btn.selected");
    const selectedSize = selectedBtn?.dataset.size;
    const currentQuantities = sizeOptions[selectedSize] || {};

    document.querySelectorAll(".product-list__item").forEach(function (item) {
      const sku = item.getAttribute("data-sku");
      const rawQty = currentQuantities[sku];

      if (rawQty === "NA") {
        item.style.display = "none";
      } else {
        item.style.display = "flex";
      }
    });
  }

  function updateQuantities(sizeKey) {
    const newQuantities = sizeOptions[sizeKey] || {};

    skus.forEach(({ input, sku }) => {
      const newQty = newQuantities[sku];
      const itemEl = input.closest(".product-list__item");
      const titleEl = itemEl?.querySelector(".product-list__title");
      const optionalTag = titleEl?.querySelector(".optional-label");

      if (newQty === "NA") {
        if (itemEl) itemEl.style.display = "none";
        return;
      }

      // Set input value
      input.value = newQty === "OP" ? 0 : newQty;

      // Remove any previous "optional" labels
      if (optionalTag) {
        optionalTag.remove();
      }

      // Add "optional" label if needed
      if (newQty === "OP" && titleEl) {
        const span = document.createElement("span");
        span.className = "optional-label";
        span.textContent = " (optional)";
        span.style.display = "inline-block";
span.style.marginLeft = "0.5rem";
span.style.padding = "4px 12px";
span.style.fontSize = "1.4rem";
span.style.backgroundColor = "#e1ecf4";
span.style.borderRadius = "12px";
span.style.lineHeight = "1";
span.style.verticalAlign = "middle";
        titleEl.appendChild(span);
      }

      // Update line item price
      const priceEl = itemEl?.querySelector(".product-list__price");
      if (priceEl) {
        const unitPrice = parseFloat(priceEl.dataset.price) / 100;
        priceEl.textContent = "$" + (unitPrice * input.value).toFixed(2);
      }
    });

    updateTotal();
    updateItemVisibility();
  }

  function updateButtonStates(selectedKey) {
    buttons.forEach(button => {
      if (button.dataset.size === selectedKey) {
        button.classList.add("selected");
      } else {
        button.classList.remove("selected");
      }
    });
  }

  // Manual quantity input
  if (window.location.pathname.includes('/collections/') && document.querySelector('.product-list')) {
    document.querySelectorAll('input[type="number"]').forEach(input => {
      input.addEventListener('input', function () {
        updateTotal();
      });
    });
  }

  // System size button click logic
  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const sizeKey = this.dataset.size;
      updateQuantities(sizeKey);
      updateButtonStates(sizeKey);
    });
  });

  // Initial default render
  const defaultSizeKey = document.querySelector('.system-size-btn.selected')?.dataset.size;
  if (defaultSizeKey) {
    updateQuantities(defaultSizeKey);
    updateButtonStates(defaultSizeKey);
  }

  updateTotal();
});
